export default __webpack_public_path__ + "static/media/gamestack-list-large.e97c029c.jpg";